class BuyBox extends HTMLElement {
  constructor() {
    super();
    this.variantId = this.dataset.variantId;
    this.cartAddUrl = this.dataset.cartAddUrl;
    this.checkoutUrl = this.dataset.checkoutUrl;

    this.thumbnails = Array.from(this.querySelectorAll('[data-gallery-thumb]'));
    this.mainImages = Array.from(this.querySelectorAll('[data-gallery-main]'));
    this.thumbnails.forEach((thumb) => {
      thumb.addEventListener('click', this.onThumbnailClick.bind(this, thumb));
    });

    this.planButtons = Array.from(this.querySelectorAll('[data-plan-option]'));
    this.planButtons.forEach((button) => {
      button.addEventListener('click', this.onPlanClick.bind(this, button));
    });

    this.addToCartButton = this.querySelector('[data-add-to-cart]');
    this.errorEl = this.querySelector('[data-add-to-cart-error]');
    if (this.addToCartButton) {
      this.addToCartButton.addEventListener('click', this.onAddToCart.bind(this));
    }

    this.accordionItems = Array.from(this.querySelectorAll('[data-accordion-item]'));
    this.accordionItems.forEach((item) => {
      const toggle = item.querySelector('[data-accordion-toggle]');
      toggle.addEventListener('click', this.onAccordionToggle.bind(this, item));
    });
  }

  onThumbnailClick(thumb) {
    if (thumb.classList.contains('is-active')) return;

    const key = thumb.dataset.galleryThumb;

    this.thumbnails.forEach((otherThumb) => {
      const isTarget = otherThumb === thumb;
      otherThumb.classList.toggle('is-active', isTarget);
      otherThumb.setAttribute('aria-selected', isTarget);
    });

    this.mainImages.forEach((image) => {
      const isTarget = image.dataset.galleryMain === key;
      image.classList.toggle('is-active', isTarget);
      image.toggleAttribute('hidden', !isTarget);
    });
  }

  onPlanClick(button) {
    if (button.classList.contains('is-selected')) return;

    this.planButtons.forEach((otherButton) => {
      const isTarget = otherButton === button;
      otherButton.classList.toggle('is-selected', isTarget);
      otherButton.setAttribute('aria-checked', isTarget);
    });
  }

  getSelectedPlanButton() {
    return this.planButtons.find((button) => button.classList.contains('is-selected'));
  }

  async onAddToCart() {
    if (!this.addToCartButton || this.addToCartButton.classList.contains('is-loading')) return;

    this.setError('');
    this.addToCartButton.classList.add('is-loading');

    const selectedPlanButton = this.getSelectedPlanButton();
    const sellingPlanId = selectedPlanButton ? selectedPlanButton.dataset.sellingPlanId : '';

    const item = {
      id: this.variantId,
      quantity: 1,
    };
    if (sellingPlanId) {
      item.selling_plan = sellingPlanId;
    }

    try {
      const response = await fetch(this.cartAddUrl, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
        body: JSON.stringify({ items: [item] }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.description || data.message || 'Unable to add this item to your cart.');
      }

      window.location.href = this.checkoutUrl;
    } catch (error) {
      this.addToCartButton.classList.remove('is-loading');
      this.setError(error.message);
    }
  }

  setError(message) {
    if (!this.errorEl) return;
    this.errorEl.textContent = message;
    this.errorEl.toggleAttribute('hidden', !message);
  }

  onAccordionToggle(item) {
    const isOpen = item.classList.contains('is-open');

    this.accordionItems.forEach((otherItem) => {
      const shouldOpen = otherItem === item && !isOpen;
      const toggle = otherItem.querySelector('[data-accordion-toggle]');
      const panel = otherItem.querySelector('[data-accordion-panel]');

      otherItem.classList.toggle('is-open', shouldOpen);
      toggle.setAttribute('aria-expanded', shouldOpen);
      panel.toggleAttribute('hidden', !shouldOpen);
    });
  }
}

customElements.define('buy-box', BuyBox);
